var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us-slide"},[_c('div',{staticClass:"left-part"},[_c('h2',{staticClass:"slide-title"},[_vm._v(_vm._s(_vm.slide.title))]),_c('p',{staticClass:"slide-desc",domProps:{"innerHTML":_vm._s(_vm.slide.desc)}})]),_c('div',{staticClass:"right-part"},[_c('img',{attrs:{"src":_vm.slide.img,"alt":"about-slider-slide"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }